import type { ReactElement } from 'react'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'
import type { UrgencyTone } from 'app/lib/boardCardFacts'
import { cn } from 'app/lib/utils'
import type { ContactJson } from 'app/types/entities'

const URGENCY_TEXT: Record<UrgencyTone, string> = {
  calm: `text-subtle`,
  soon: `text-amber-700`,
  late: `text-red-600`,
}

/** Name and age, with the urgency figure (the wait, or the cleaning countdown) opposite. */
export function NameRowSection({
  contact,
  derived,
}: {
  contact: ContactJson
  derived: ContactCardFacts
}): ReactElement {
  const { age, figure, tone } = derived
  return (
    <div className="flex items-baseline justify-between gap-2">
      <p className="min-w-0 truncate text-ui-sm text-strong">
        {contact.name}
        {age != null && <span className="text-minimal">, {age}</span>}
      </p>
      {figure && <span className={cn(`shrink-0 text-body-xs`, URGENCY_TEXT[tone])}>{figure}</span>}
    </div>
  )
}
